const colors = [
  'rgba(255, 70, 70, 1)',
  'rgba(255, 160, 20, 1)',
  'rgba(100, 200, 80, 1)',
  'rgba(30, 180, 200, 1)',
  'rgba(70, 80, 250, 1)',
  'rgba(180, 70, 240, 1)',
  'rgba(255, 160, 150, 1)',
  'rgba(255, 200, 120, 1)',
  'rgba(150, 230, 200, 1)',
  'rgba(110, 220, 240, 1)',
  'rgba(170, 170, 255, 1)',
  'rgba(230, 180, 250, 1)',
  'rgba(260, 0, 0, 1)',
  'rgba(150, 70, 0, 1)',
  'rgba(190, 170, 30, 1)',
  'rgba(60, 120, 40, 1)',
  'rgba(40, 100, 140, 1)',
  'rgba(30, 40, 140, 1)',
  'rgba(100, 30, 140, 1)',
];

export const themeDefault = { buttonElements: colors, threads: colors };
